import { render, staticRenderFns } from "./SelectStudent.vue?vue&type=template&id=582e40ea&scoped=true"
import script from "./SelectStudent.vue?vue&type=script&lang=js"
export * from "./SelectStudent.vue?vue&type=script&lang=js"
import style0 from "./SelectStudent.vue?vue&type=style&index=0&id=582e40ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e40ea",
  null
  
)

export default component.exports